import EventLocationsView from './components/event-locations-view';

export default EventLocationsView;
